import Vue from 'vue'
// import Vuetify from 'vuetify'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  transitions,
  VForm,
  VMenu,
  VInput,
  VTooltip,
  VCard,
  VTextField,
  VProgressCircular,
  VCombobox,
  VDialog,
  VSubheader,
  VDivider,
  VTabs,
  VResponsive,
  VProgressLinear,
  VSnackbar
} from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VForm,
    VMenu,
    VInput,
    VTooltip,
    VCard,
    VTextField,
    VProgressCircular,
    VCombobox,
    VDialog,
    VSubheader,
    VDivider,
    VTabs,
    VResponsive,
    VProgressLinear,
    VSnackbar
  },
  theme: {
    // primary: '#ee44aa',
    primary: '#2A2F50',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})
